"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteOAuth = exports.deleteJWT = exports.setOAuth = exports.setJWT = exports.getOAuth = exports.getJWT = exports.OAUTH_COOKIE = exports.JWT_COOKIE = void 0;
exports.JWT_COOKIE = 'manifoldJWT';
exports.OAUTH_COOKIE = 'manifoldOAuth';
var getJWTKey = function (address, strict) {
    return strict ? exports.JWT_COOKIE + ":" + (address === null || address === void 0 ? void 0 : address.toLowerCase()) : exports.JWT_COOKIE;
};
var getOAuthKey = function (address, strict) {
    return strict ? exports.OAUTH_COOKIE + ":" + (address === null || address === void 0 ? void 0 : address.toLowerCase()) : exports.OAUTH_COOKIE;
};
var getJWT = function (address, strict) {
    return localStorage.getItem(getJWTKey(address, strict));
};
exports.getJWT = getJWT;
var getOAuth = function (address, strict) {
    return localStorage.getItem(getOAuthKey(address, strict));
};
exports.getOAuth = getOAuth;
var setJWT = function (address, strict, jwt) {
    localStorage.setItem(getJWTKey(address, strict), jwt);
};
exports.setJWT = setJWT;
var setOAuth = function (address, strict, token) {
    localStorage.setItem(getOAuthKey(address, strict), token);
};
exports.setOAuth = setOAuth;
var deleteJWT = function (address, strict) {
    localStorage.removeItem(getJWTKey(address, strict));
};
exports.deleteJWT = deleteJWT;
var deleteOAuth = function (address, strict) {
    localStorage.removeItem(getOAuthKey(address, strict));
};
exports.deleteOAuth = deleteOAuth;
